/**
 * 业务员service
 * */

import {POST,GET} from './service.config.js'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import {setSign} from "../MD5";


/**
 * 业务员登录
 * @param saleTel 业务员账号
 * @param salePass 业务员密码
 * @param openId 微信openID
 */
export const salemanLoginService = (saleTel,salePass,openId) => POST('btrexchange/salemanLogin',{
    tel:saleTel,
    password:md5(salePass),
    openid:openId,
});


/**
 * 获取业务员信息
 * @param saleId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSalesmanInfoService = saleId => POST('btrexchange/getSalemanInfo',{saleman_id:saleId});


/**
 * 修改业务员登录密码
 * @param tel 用户电话
 * @param pass 用户密码
 * @param code 验证码
 * @returns {*|Promise|Promise<unknown>}
 */
export const salesmanChangePassService = (tel,pass,code) => POST('btrexchange/changePass',{
    tel,
    code,
    pass:md5(pass),
});


/**
 * 商家报备新增
 * @param shopInfo 商家信息
 * @param userId 业务员ID
 * @param business_status 0 业务员申请 1商家自己申请
 * @returns {*|Promise|Promise<unknown>}
 */
export const addPrepareShopService = (shopInfo,userId,state,type = 0) => POST('btrexchange/addBusiness',{
    shop_name:shopInfo.name,
    shop_tel:shopInfo.tel,
    contacts_name:shopInfo.contacts,
    contacts_tel:shopInfo.contactsTel,
    province:shopInfo.provinceId,
    city:shopInfo.cityId,
    district: shopInfo.districtId,
    address:shopInfo.addressDetail,
    remarks:shopInfo.remarks || '',
    type:type,
    sid: userId,
    business_status:state,
});

/**
 * 报备商家列表
 * @param saleId 业务员ID 默认为0：表示所有商家
 * @param shopName 店铺名称
 * @param contactsTel 联系人电话
 * @param page 页码
 * @param limit 每页显示行数
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getPrepareListService = (shopName,contactsTel,page,limit,saleId = 0,startDate = null,endDate = null) => POST('btrexchange/businessList',{
    saleman_id:saleId,
    shop_name:shopName,
    contacts_tel:contactsTel,
    page,
    limit,
    source_status:1, //标识公众号
    start_time:startDate ,
    end_time:endDate,
});


/**
 * 报备商家详情
 * @param shopId 商家ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getPrepareDetailsService = shopId => POST('btrexchange/businessDetail',{
    id:shopId,
});


/**
 * 报备商家新增跟进信息
 * @param shopId 店铺ID
 * @param followUp 跟进信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const setFollowUpService = (shopId,followUp) => POST('btrexchange/addFollowup',{
    shop_id:shopId,
    content:followUp,
});

/**
 * 报备商家签约
 * @param shopId 店铺ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const setSignTheBillService = (shopId) => POST('btrexchange/editBusiness',{
    id:shopId,
});


/**
 * 业务员团队信息
 * @param saleId 业务员编号
 * @returns {*|Promise<unknown>}
 */
export const getTeamService = saleId => POST('btrexchange/getTeam',{saleman_id:saleId});



/**
 * 获取业务员身份
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSalesmanLeaveService = () => GET('btrexchange/getSalesmanLeave');


/**
 * 获取上级身份
 * @param levelId 自己身份的ID
 * @param key 关键字
 * @returns {*|Promise|Promise<unknown>}
 */
export const getLeaveByLeaveByNameService = (levelId,key) => POST('btrexchange/getLeaveByLeaveName',{
    level:levelId,
    name:key,
});


/**
 * 业务员注册
 * @param saleInfo 业务员信息
 * @param pass 密码
 * @returns {*|Promise|Promise<unknown>}
 */
export const salesmanRegisterService = (saleInfo,pass,openID) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    let formData = new FormData();
    saleInfo.password = md5(pass);
    const signTxt = qs.stringify(saleInfo) + '&openid=' + openID;
    formData.append('name',saleInfo.name.trim());//业务员名称
    formData.append('tel',saleInfo.tel.trim());//业务员电话
    formData.append('idnum',saleInfo.idnum.trim());//业务员身份证号
    formData.append('password',saleInfo.password.trim());//业务员密码
    formData.append('level_id',saleInfo.level_id);//业务员等级ID
    formData.append('level',saleInfo.level);//业务员等级
    formData.append('parent_id',saleInfo.parent_id);//业务员上级编号
    formData.append('province',saleInfo.province);//业务员地址省
    formData.append('city',saleInfo.city);//业务员地址县
    formData.append('district',saleInfo.district);//业务员地区区
    formData.append('address',saleInfo.address.trim());//业务员详细地址
    formData.append('idimg_z',saleInfo.idimg_z);//业务员身份证a面
    formData.append('idimg_b',saleInfo.idimg_b);//业务员身份证b面
    formData.append('openid',openID);//openID
    formData.append('sign',setSign(signTxt));//加密

    return new Promise((resolve, reject) => {
        axios.post('btrexchange/salesmanRegister',formData,config).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
};


/**
 * 获取行业类别
 * @returns {*|Promise<unknown>}
 */
export const getCategoryService = () => POST('btrexchange/industryCategory');

/**
 * 获取行业类别
 * @returns {*|Promise<unknown>}
 */
export const getCategoryService2 = (pid) => POST('btrexchange/industryCategory2',{
	pid:pid
});

/**
 * 商家入驻
 * @param saleId 业务员ID
 * @param shopInfo 商家信息
 * @param pass 密码
 * @returns {Promise<unknown>}
 */
export const shopRegisterService = (saleId,shopInfo,pass) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    let formData = new FormData();
    shopInfo.password = md5(pass);
    const signTxt = qs.stringify(shopInfo) + '&saleman_id=' + saleId;
    formData.append('saleman_id',saleId);
    formData.append('name',shopInfo.name);//商家名称
    formData.append('company_name',shopInfo.company_name);//公司名称
    formData.append('email',shopInfo.email);//公司email
    formData.append('remarks',shopInfo.remarks);//商家介绍
    formData.append('person',shopInfo.person);//联系人姓名
    formData.append('tel',shopInfo.tel);//商家电话
    formData.append('password',shopInfo.password);//商家密码
    formData.append('platform_cc',shopInfo.platform_cc);//提成比例
    formData.append('user_hb',shopInfo.user_hb);//红包比例
    // formData.append('person_idnum',shopInfo.person_idnum.trim());//商家联系人身份证号
    formData.append('province',shopInfo.province);//商家所在省
    formData.append('city',shopInfo.city);//商家所在市
    formData.append('district',shopInfo.district);//商家坐在区
    formData.append('address',shopInfo.address);//商家详细地址
    formData.append('taxpayer_num',shopInfo.taxpayer_num);//纳税人识别号
    formData.append('legal_name',shopInfo.legal_name);//法人
    formData.append('legal_idnum',shopInfo.legal_idnum);//法人身份证号
    formData.append('category_id',shopInfo.category_id);//经营类别id
    formData.append('logo',shopInfo.logo);//商家logo
    formData.append('img_id_a',shopInfo.img_id_a);//身份证正面照
    formData.append('img_id_b',shopInfo.img_id_b);//身份证背面照
    formData.append('yyzz_img',shopInfo.yyzz_img);//营业执照照片
    // formData.append('sign',setSign(signTxt));//加密
    return new Promise((resolve, reject) => {
        axios.post('btrexchange/shopRegister',formData,config).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
};


/**
 * 获取我签约的商家列表
 * @param saleId 业务员ID
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopSalemanService = (saleId,page,limit,startDate,endDate) => POST('btrexchange/shop_saleman',{
    saleman_id:saleId,
    page,
    limit,
    source_status:1, //标识公众号
    start_time:startDate,
    end_time:endDate,
});


/**
 * 获取我签约的商家的流水
 * @param saleId 业务员ID
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopSalemanFlowingService = (saleId,page,limit,startDate,endDate) => POST('btrexchange/saleman_flow',{
    saleman_id:saleId,
    page,
    limit,
    source_status:1, //标识公众号
    start_time:startDate,
    end_time:endDate,
});



/**
 * 业务员提现提现
 * @param saleId 业务员ID
 * @param price 提现金额
 * @param pass 提现密码
 * @param openId
 * @returns {*|Promise|Promise<unknown>}
 */
export const setDoTxSaleService = (saleId,price,pass,openId) => POST('btrexchange/cash',{
    saleman_id:saleId,
    amount:price,
    password:md5(pass),
    openid:openId,
    source_status:1,
});


/**
 * 业务员提现记录
 * @param saleId 业务员ID
 * @param page 当前页码
 * @param limit 每页显示行数
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise<unknown>}
 */
export const getSaleRecordsListService = (saleId,page,limit,startDate,endDate) => POST('btrexchange/cashList',{
    saleman_id:saleId,
    page,
    limit,
    // source_status:1, //标识公众号
    start_time:startDate,
    end_time:endDate,
});


/**
 * 获取业务员余额变更记录
 * @param saleId 业务员ID
 * @param page 当前页码
 * @param limit 每页显示行数
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getRoyaltyListService = (saleId,page,limit,startDate,endDate) => POST('btrexchange/getRoyaltyList',{
    saleman_id:saleId,
    page,
    limit,
    source_status:1, //标识公众号
    start_time:startDate,
    end_time:endDate,
});

/**
 * 商家签售合同
 * @param shopId 商家ID
 * @param img 图片
 * @param oleImg
 * @param tel 商家电话
 * @returns {*|Promise|Promise<unknown>}
 */
export const sendShopContractService = (shopId,img,oleImg,tel) => POST('btrexchange/signShopContract',{
    shop_id:shopId,
    ht:oleImg,
    sign_img:img,
    tel,
});

/**
 * 业务员签售合同
 * @param saleId 业务员ID
 * @param img
 * @param oleImg
 * @returns {*|Promise|Promise<unknown>}
 */
export const sendSaleContractService = (saleId,img,oleImg,tel,level) => POST('btrexchange/signSaleContract',{
    saleman_id:saleId,
    ht:oleImg,
    sign_img:img,
    tel,
    level,
});

/**
 * 获取业务员合同
 * @param saleId 业务员ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSaleContractService = saleId => POST('btrexchange/getSaleContract',{
    saleman_id:saleId,
});


/**
 * 获取业务员信息
 * @param id 业务员ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSaleInfoByNumService = id => POST('btrexchange/salemanDetail',{
    id,
});


/**
 * 修改业务员提现密码
 * @param tel
 * @param pass
 * @param code 验证码
 * @param saleId
 * @returns {*|Promise|Promise<unknown>}
 */
export const salesmanChangePayPassService = (tel,pass,saleId,code) => POST('btrexchange/saveSalemanZfpass',{
    tel,
    saleman_id:saleId,
    code,
    password:md5(pass),
});

/**
 * 业务员退出登录
 * @param saleId 业务员ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOutService = saleId => POST('btrexchange/salemanGetOut',{saleman_id:saleId});


/**
 * 获取业务员统计信息
 * @param saleId
 * @param stareDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopStatisticsService = (saleId,stareDate,endDate) => POST('btrbasic/salemanStatistics',{
    saleman_id:saleId,
    start_time:stareDate,
    end_time:endDate,
});


/**
 * 获取我的分享码
 * @param saleId 业务员ID
 * @param url 分享地址
 * @returns {Promise | Promise<unknown>}
 */
export const getShareImgService = (url,saleId) => POST('btrsaleman/getSalemanQrcode',{
    saleman_id:saleId,
    url,
});

/**
 * 获取分享注册用户列表
 * @param saleId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getShareListService = (saleId,page,limit,startDate,endDate) => POST('btrbasic/saleman_lock',{
    saleman_id:saleId,
    page,
    limit,
    start_time:startDate,
    end_time:endDate,
});


/**
 * 获取分享注册用户提成列表
 * @param saleId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getShareListTCService = (saleId,page,limit,startDate,endDate) => POST('btrbasic/saleman_lock_record',{
    saleman_id:saleId,
    page,
    limit,
    start_time:startDate,
    end_time:endDate,
});